import { FC, PropsWithChildren } from 'react';

import styles from './index.less';

interface Props {
    percent: number;
}

const IconCirclePercent: FC<Props & PropsWithChildren> = ({ percent }) => {
    const width = 7;
    const stroke = 3;
    const radius = (width * 2 - stroke) / 2;
    const circularPerimeter = radius * 2 * Math.PI;
    const strokePercentValue = circularPerimeter * (percent / 100);
    const strokeMainValue = circularPerimeter - strokePercentValue;
    /* Разница diffCount нужна для корректного отображения процентов в 4 четверти (из-за закруглённых углов без отступов выглядит некорректно) */
    const diffCount = percent > 75 && percent < 100 ? 3 : 1;
    const strokePercentValueDashArray = `${
        strokePercentValue > stroke ? strokePercentValue - diffCount : strokePercentValue
    } ${strokeMainValue + 3}`;

    return (
        <svg width={width * 2} height={width * 2} className={styles.svg}>
            <g fill="none">
                <circle
                    r={radius}
                    cx={width}
                    cy={width}
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={`${circularPerimeter} ${circularPerimeter}`}
                    className={styles.svgCircle}
                />

                <circle
                    r={radius}
                    cx={width}
                    cy={width}
                    transform={`rotate(-90 ${width} ${width})`}
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={strokePercentValueDashArray}
                    className={styles.svgCircleColored}
                />
            </g>
        </svg>
    );
};

export default IconCirclePercent;
